// src/components/geral/PageHeader.js
import React from 'react';
import './PageHeader.css';

const PageHeader = ({children}) => {


  return (
    <div className="page-content-header">
      {children}
    </div>
  );
};

export default PageHeader;
